module.exports = __webpack_public_path__ + "img/5_77.670ec945.png";